import { IInativarServicoProdutoLoteServicoProdutoUseCase } from "../../../presentation/useCases/update/inativar_servico_produto_lote_servico_produto_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * InativarServicoProdutoLoteServicoProdutoUseCase
 */

export class InativarServicoProdutoLoteServicoProdutoUseCase
  implements IInativarServicoProdutoLoteServicoProdutoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async inativarServicoProdutoLoteServicoProduto(
    idsProdutoServico: Set<string | number>,
  ): Promise<void> {
    await this.repository.inativarServicoProdutoLoteServicoProduto(
      Array.from(idsProdutoServico).map(x => {
        if (typeof x === 'number') return x;
        if (typeof x === 'string') return Number(x);
        throw new Error('Id de modelo invalido!');
      })
    );
  }
}
